export default class Search  {
    constructor() {
        this.header = document.querySelector(".header-main");
        this.navSearchOpenTriggers = document.querySelectorAll('.search-form-open-trigger');
        this.searchForm = document.querySelector("#search-form-main");
        this.searchFormClose = document.querySelector("#search-form-main .search-form-close");

        if (this.navSearchOpenTriggers.length > 0 && this.searchForm && this.searchFormClose) {
            this.initNavSearch();
        }
    }

    initNavSearch() {
        this.navSearchOpenTriggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                this.showSearchBar(e);

                if (this.header.classList.contains("hide")) {
                    setTimeout(() => {
                        this.header.classList.remove('hide');
                    }, 300);
                }
            });
        });

        document.addEventListener("escape.pressed", (e) => {
            this.hideSearchBar(e);
        });

        this.searchFormClose.addEventListener('click', (e) => {
            this.hideSearchBar(e);
        });
    }

    hideSearchBar(e) {
        e.preventDefault();
        this.searchForm.classList.remove('is-visible');
        this.searchForm.setAttribute('inert', '');
        this.navSearchOpenTriggers.forEach(t => t.setAttribute('aria-expanded', 'false'));
    }

    showSearchBar(e) {
        e.preventDefault();
        this.searchForm.removeAttribute('inert');
        this.searchForm.classList.add('is-visible');
        this.searchForm.querySelector("input").focus();
        this.navSearchOpenTriggers.forEach(t => t.setAttribute('aria-expanded', 'true'));
    }
}